export const required = v => !!v || 'Campo Obrigatório'
export const email_required = v => /.+@.+/.test(v) || 'Formato de E-mail Inválido'